export default "/images/vendor/flag-icon-css/flags/4x3/tf.svg?b52f02c3eaacdccd3a787e5f4c495683";